import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const FileRowPlaceholder: React.FC<IContentLoaderProps> = (props) => (
  <ContentLoader
    className="file-selector-loading"
    viewBox="0 0 600 36"
    preserveAspectRatio="none"
    width="100%"
    height={40}
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="4" ry="4" width="100%" height="36" />
  </ContentLoader>
);

export default FileRowPlaceholder;
